module.exports = __webpack_public_path__ + "static/media/SPM.bd2354c6.pdf";